export interface Category {
  slug: string;
  name: string;
  description: string;
  count: number;
  imageUrl: string;
  tags: string[];
}

export const categories: Category[] = [
  {
    slug: 'riman',
    name: '日漫精选',
    description: '收录最全的日本成人漫画，涵盖同人志、商业志、杂志连载等，题材丰富多样，画风精致细腻。',
    count: 12860,
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20artistic%20background%20with%20flowing%20organic%20shapes%2C%20soft%20gradient%20textures%2C%20minimalist%20manga%20inspired%20composition%2C%20elegant%20coral%20and%20cream%20tones%2C%20subtle%20paper%20texture%2C%20clean%20modern%20design%2C%20no%20text%20or%20characters&width=800&height=600&seq=cat-riman-01&orientation=landscape',
    tags: ['同人志', '商业志', '连载', '短篇']
  },
  {
    slug: 'hanman',
    name: '韩漫精选',
    description: '韩国成人漫画专区，以独特的纵向滚动阅读方式和精美上色著称，剧情引人入胜。',
    count: 9520,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20amber%20and%20cream%20abstract%20background%20with%20flowing%20organic%20shapes%2C%20soft%20layered%20textures%2C%20minimalist%20composition%20with%20elegant%20curves%2C%20subtle%20gradient%20washes%2C%20modern%20artistic%20style%2C%20no%20text&width=800&height=600&seq=cat-hanman-02&orientation=landscape',
    tags: ['全彩', '长条', '剧情', '都市']
  },
  {
    slug: 'oumei',
    name: '欧美漫画',
    description: '欧美成人漫画集合，包含美式超级英雄风格、写实画风、哥特暗黑等多种流派作品。',
    count: 6340,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20warm%20toned%20abstract%20geometric%20background%20with%20bold%20flowing%20shapes%2C%20rich%20gradient%20textures%2C%20minimalist%20composition%2C%20deep%20coral%20and%20charcoal%20tones%2C%20artistic%20modern%20design%2C%20no%20text&width=800&height=600&seq=cat-oumei-03&orientation=landscape',
    tags: ['写实', '超级英雄', '暗黑', '科幻']
  },
  {
    slug: '3d',
    name: '3D漫画',
    description: '采用3D建模渲染技术创作的成人漫画，画面逼真立体，带来身临其境的视觉体验。',
    count: 4180,
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20warm%20toned%20abstract%20background%20with%20smooth%20flowing%20gradients%2C%20soft%20metallic%20textures%2C%20minimalist%20artistic%20composition%2C%20coral%20and%20cream%20color%20palette%2C%20clean%20contemporary%20design%2C%20no%20text&width=800&height=600&seq=cat-3d-04&orientation=landscape',
    tags: ['3D渲染', 'CG', '高精度', '真实感']
  },
  {
    slug: 'guoman',
    name: '国漫精选',
    description: '国产原创成人漫画专区，支持国内画师创作，风格融合传统国风与现代审美。',
    count: 3850,
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20abstract%20background%20with%20traditional%20ink%20wash%20inspired%20textures%2C%20soft%20flowing%20gradients%2C%20minimalist%20artistic%20composition%2C%20coral%20and%20gold%20accents%2C%20refined%20modern%20design%2C%20no%20text&width=800&height=600&seq=cat-guoman-05&orientation=landscape',
    tags: ['原创', '国风', '彩漫', '连载']
  },
  {
    slug: 'duanpian',
    name: '短篇合集',
    description: '精选短篇成人漫画合集，适合碎片化时间阅读，每篇故事独立完整，节奏紧凑。',
    count: 8720,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20collage%20style%20background%20with%20layered%20geometric%20shapes%2C%20soft%20textured%20gradients%2C%20minimalist%20composition%2C%20coral%20and%20cream%20aesthetic%2C%20clean%20modern%20design%2C%20no%20text&width=800&height=600&seq=cat-duanpian-06&orientation=landscape',
    tags: ['短篇', '合集', '完结', '独立故事']
  },
  {
    slug: 'changpian',
    name: '长篇连载',
    description: '长篇成人漫画连载专区，剧情丰富，角色立体，适合喜欢深度阅读的漫画爱好者。',
    count: 5640,
    imageUrl: 'https://readdy.ai/api/search-image?query=Deep%20warm%20toned%20abstract%20background%20with%20flowing%20continuous%20lines%2C%20rich%20layered%20textures%2C%20minimalist%20composition%2C%20coral%20and%20sand%20color%20palette%2C%20elegant%20modern%20design%2C%20no%20text&width=800&height=600&seq=cat-changpian-07&orientation=landscape',
    tags: ['长篇', '连载中', '剧情', '系列']
  },
  {
    slug: 'remen',
    name: '热门排行',
    description: '实时更新的热门成人漫画排行榜，基于用户阅读量和评分数据，发现最受欢迎的漫画作品。',
    count: 2150,
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20warm%20toned%20abstract%20background%20with%20dynamic%20flowing%20shapes%2C%20bold%20soft%20gradients%2C%20minimalist%20artistic%20composition%2C%20coral%20and%20amber%20highlights%2C%20energetic%20modern%20design%2C%20no%20text&width=800&height=600&seq=cat-remen-08&orientation=landscape',
    tags: ['排行榜', '热门', '推荐', '高分']
  }
];